var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPentester(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.586,
    height: 31.228,
    viewBox: "0 0 32.586 31.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pentest_portal-2",
    transform: "translate(3000.327 -1273.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    transform: "translate(-3000.327 1273.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    d: "M-3121.923,1291.079l-.627-.517a44.4,44.4,0,0,1-11.519-14,41.429,41.429,0,0,1-4.028-12.963l-.119-.806.77-.267a47.068,47.068,0,0,1,15.458-2.67,48.238,48.238,0,0,1,15.581,2.667l.776.265-.12.811a41.435,41.435,0,0,1-4.027,12.965,44.4,44.4,0,0,1-11.52,14Zm-14.1-26.96c1.049,6.44,3.788,15.622,14.1,24.4,10.31-8.776,13.05-17.957,14.1-24.4a46.037,46.037,0,0,0-14.163-2.3A44.921,44.921,0,0,0-3136.024,1264.119Z",
    transform: "translate(3138.216 -1259.851)",
    fill: "#ed2224"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    transform: "translate(6.208 4.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    d: "M-2989.644,1288.127l-1.79-.821a22.828,22.828,0,0,0,1.712-5.574,27.169,27.169,0,0,0-6.324-1.186l.125-1.966a29.423,29.423,0,0,1,7.624,1.544l.776.264-.119.811A25.294,25.294,0,0,1-2989.644,1288.127Z",
    transform: "translate(3007.691 -1278.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    d: "M-3112.2,1288.1a25.224,25.224,0,0,1-2-6.924l-.119-.807.77-.267a28.605,28.605,0,0,1,7.632-1.551l.12,1.966a26.4,26.4,0,0,0-6.322,1.186,22.846,22.846,0,0,0,1.712,5.577Z",
    transform: "translate(3114.318 -1278.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    d: "M-3067.381,1406.243l-.627-.517a28.013,28.013,0,0,1-5.432-5.895l1.633-1.1a25.584,25.584,0,0,0,4.427,4.946,25.616,25.616,0,0,0,4.426-4.946l1.633,1.1a28.019,28.019,0,0,1-5.432,5.9Z",
    transform: "translate(3077.465 -1386.897)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    cx: 1.772,
    cy: 1.772,
    r: 1.772,
    transform: "translate(14.52 10.921)",
    fill: "#ed2224"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentester);
export default __webpack_public_path__ + "static/media/pentester.dac61012404f60e02928772dc221a59a.svg";
export { ForwardRef as ReactComponent };